import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface UIState {
  sidebarCollapsed: boolean;
  density: 'compact' | 'normal' | 'comfortable';
  commandPaletteOpen: boolean;
  helpOpen: boolean;

  toggleSidebar: () => void;
  setDensity: (density: UIState['density']) => void;
  setCommandPaletteOpen: (open: boolean) => void;
  setHelpOpen: (open: boolean) => void;
}

export const useUIStore = create<UIState>()(
  persist(
    (set) => ({
      sidebarCollapsed: false,
      density: 'normal',
      commandPaletteOpen: false,
      helpOpen: false,

      toggleSidebar: () => set((s) => ({ sidebarCollapsed: !s.sidebarCollapsed })),
      setDensity: (density) => set({ density }),
      setCommandPaletteOpen: (open) => set({ commandPaletteOpen: open }),
      setHelpOpen: (open) => set({ helpOpen: open }),
    }),
    {
      name: 'axioma-ui',
      partialize: (state) => ({
        sidebarCollapsed: state.sidebarCollapsed,
        density: state.density,
      }),
    },
  ),
);
